import React, { createContext, useContext, useState } from 'react'

const NotificationContext = createContext({})

const NotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([])

  const AddNotification = (payload) => {
    setNotifications((prev) => [...prev, payload])
  }

  const RemoveNotification = (index) => {
    const temp = [...notifications]
    temp.slice(index, 1)
    setNotifications(temp)
  }

  return (
    <NotificationContext.Provider value={{ notifications, AddNotification, RemoveNotification }}>
      {children}
    </NotificationContext.Provider>
  )
}

const useNotifications = () => {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotifications must be used within an NotificationsProvider')
  }
  return context
}

export { NotificationsProvider, useNotifications }
